import * as prismic from '@prismicio/client';
import { enableAutoPreviews } from '@prismicio/next';

import sm from './slicemachine.config.json';

export const repositoryName = sm.repositoryName;

// tell prismic where sites will be served
export const linkResolver = (doc) => {
  switch (doc.type) {
    case 'blog':
      return `/article/${doc.uid}`;
    case 'help':
      return `/help/${(doc.data?.category || 'design').toLowerCase()}/${
        doc.uid
      }`;
    case 'landingPage':
      return `/${doc.data?.path || 'feature'}/${doc.uid}`;
    case 'pricing':
      return `/pricing`;
    case 'licensing':
      return `/licensing`;
    case 'feature':
      return `/feature`;
    case 'create':
      return `/create`;
    case 'x':
      return `/x`;
    case 'tools':
      return `/tools`;
    case 'partners':
      return `/partners`;
    case 'education':
      return `/education`;
    case 'discover':
      return `/discover`;
    case 'non-feed-footer':
      return `/legal`; // this could be any non feed page
    case 'affiliates':
      return `/affiliates`;
    case 'searchPage':
      if (doc.data?.category === doc.uid) {
        return `/inspiration/${doc.data.category}`;
      }
      return `/inspiration/${doc.data?.category ?? 'logos'}/${doc.uid}`;
    case 'legal':
      return '/legal';
    case 'terms':
      return '/terms';
    case 'privacy':
      return '/privacy';
    case 'cancellationPolicy':
      return '/cancellation';
    case 'recruitingprivacy':
      return '/recruiting-privacy';
    default:
      return null;
  }
};

// This factory function allows smooth preview setup
export const createClient = (config = {}) => {
  const client = prismic.createClient(repositoryName, {
    ...config,
  });

  enableAutoPreviews({
    client,
    previewData: config.previewData,
    req: config.req,
  });

  return client;
};

export const getUrlFromLink = (link) => {
  if (link.link_type === 'Document') {
    const resolvedLink = linkResolver(link);

    if (!resolvedLink) {
      throw new Error(`Unable do resolve link from doc: ${link}`);
    }

    return resolvedLink;
  }

  return link.url;
};
